import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {BusinessSegmentDetail} from "./business-segment-detail";

const BusinessSegmentDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/business-segments');
    }

    return (
        <BusinessSegmentDetail id={id ? parseInt(id) : null} onClose={onClose}/>
    )

});

export default BusinessSegmentDetailPage;
